import React, { useState, useRef, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Modal,
  Platform,
  Image,
} from "react-native";
//import ActionSheet from '@expo/react-native-action-sheet'
import * as ImagePicker from "expo-image-picker";
import * as DocumentPicker from "expo-document-picker";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Spinner from "react-native-loading-spinner-overlay";
import { downloadToFolder } from "expo-file-dl";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import ModalSuccess from "../../components/ModalSuccess";
import { toast } from "../../utils/toast";
import api from "../../services/api";
import styles from "./styles";
import { If, Then, Else } from "react-if";
import GoBackButton from "../../components/GoBackButton";

const IncomeVoucher = () => {
  const [actionSheetVisible, setActionSheetVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [file, setFile] = useState();
  const [dataFile, setDataFile] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateFile, setUpdateFile] = useState(false);
  const [fileType, setFileType] = useState("");
  const [fileName, setFileName] = useState("");
  const [extensionFile, setExtensionFile] = useState("");

  useEffect(() => {
    (async () => {
      if (Platform.OS !== "web") {
        const { status } =
          await ImagePicker.requestMediaLibraryPermissionsAsync();
        const intl = useIntl();
        if (status !== "granted") {
          alert(
            intl.formatMessage({ id: "incomeVoucher.precisamosDaSuaPermissao" })
          );
        }
      }
    })();

    getData();
  }, []);

  const getData = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    setLoading(true);

    api
      .get("/income-files/details-file", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data.data.length === 0) {
          setDataFile([]);
          setLoading(false);
          console.log("log");
        } else {
          console.log(res.data.data[0]);
          setFile(res.data.data[0].file.url);
          setDataFile(res.data.data[0]);

          setUpdateFile(true);
          var type = res.data.data[0].file.mime_type.split("/");
          setFileType(type[0]);
          setExtensionFile(type[1]);

          setFileName(res.data.data[0].file.name);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast(
          intl.formatMessage({ id: "incomeVoucher.erroCarregaDados" }),
          "#DA1414"
        );
        setLoading(false);
      });
  };

  const showActionSheet = () => {
    pickDocument();
  };

  const pickImage = async () => {
    console.log(dataFile.id);
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    let result = await ImagePicker.launchImageLibraryAsync({});

    setLoading(true);

    if (result.cancelled) {
      return setLoading(false);
    }

    let localUri = result.uri;
    let filename = localUri.split("/").pop();

    let match = /\.(\w+)$/.exec(filename);
    let type = match ? `image/${match[1]}` : `image`;

    let formData = new FormData();
    formData.append("file", { uri: localUri, name: filename, type });

    if (updateFile) {
      api
        .post(`/income-files/${dataFile.id}/replace`, formData, {
          headers: {
            "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setFile(res.data.file.url);
          var type = res.data.file.mime_type.split("/");
          setFileType(type[0]);
          setExtensionFile(type[1]);
          setFileName(res.data.file.name);
          setDataFile(res.data);
          setUpdateFile(true);

          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          toast(
            intl.formatMessage({ id: "incomeVoucher.erroSalvaDados" }),
            "#DA1414"
          );
          setLoading(false);
        });
    } else {
      api
        .post("/income-files", formData, {
          headers: {
            "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setFile(res.data.file.url);
          var type = res.data.file.mime_type.split("/");
          setFileType(type[0]);
          setExtensionFile(type[1]);
          setFileName(res.data.file.name);
          setDataFile(res.data);
          setUpdateFile(true);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          toast(
            intl.formatMessage({ id: "incomeVoucher.erroSalvaDados" }),
            "#DA1414"
          );
          setLoading(false);
        });
    }
  };

  const pickDocument = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    let result = await DocumentPicker.getDocumentAsync({});

    if (result.cancelled) {
      return false;
    }

    let localUri = "file://" + result.uri;
    let filename = localUri.split("/").pop();

    let match = /\.(\w+)$/.exec(filename);
    let type = match ? `image/${match[1]}` : `image`;

    let formData = new FormData();
    formData.append("file", {
      uri: localUri.replace(/%/g, "%25"),
      name: filename,
      type,
    });

    if (updateFile) {
      setLoading(true);
      api
        .post(`/income-files/${dataFile.id}/replace`, formData, {
          headers: {
            "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setFile(res.data.file.url);
          var type = res.data.file.mime_type.split("/");
          setFileType(type[0]);
          setExtensionFile(type[1]);
          setFileName(res.data.file.name);
          setDataFile(res.data);
          setUpdateFile(true);
          setLoading(false);
        })
        .catch(() => {
          toast(intl.formatMessage({ id: "incomeVoucher.erroSalvaDados" }));
          setLoading(false);
        });
    } else {
      setLoading(true);
      api
        .post("/income-files", formData, {
          headers: {
            "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setFile(res.data.file.url);
          var type = res.data.file.mime_type.split("/");
          setFileType(type[0]);
          setExtensionFile(type[1]);
          setFileName(res.data.file.name);
          setDataFile(res.data);
          setUpdateFile(true);
          setLoading(false);
        })
        .catch(() => {
          toast(intl.formatMessage({ id: "incomeVoucher.erroSalvaDados" }));
          setLoading(false);
        });
    }
  };

  async function downloadFile() {
    if (extensionFile === "pdf") {
      await downloadToFolder(file, "comprovante.pdf", "Downloads", 1, {
        notificationType: { notification: "custom" },
        notificationContent: {
          downloading: {
            title: <FormattedMessage id="incomeVoucher.downloadEmProgresso" />,
          },
          finished: {
            title: <FormattedMessage id="incomeVoucher.downloadCompleto" />,
          },
          error: {
            title: <FormattedMessage id="incomeVoucher.houveUmErro" />,
          },
        },
        downloadProgressCallback: (data) => {
          setLoading(true);
          const { totalBytesWritten, totalBytesExpectedToWrite } = data;
          const pctg = 100 * (totalBytesWritten / totalBytesExpectedToWrite);
          if (pctg === 100) {
            setLoading(false);
            toast(
              intl.formatMessage({
                id: "incomeVoucher.erroVerificaGaleriaArquivos",
              })
            );
          }
        },
      });
    } else {
      await downloadToFolder(file, "comprovante.jpg", "Downloads", 1, {
        notificationType: { notification: "custom" },
        notificationContent: {
          downloading: {
            title: <FormattedMessage id="incomeVoucher.downloadEmProgresso" />,
          },
          finished: {
            title: <FormattedMessage id="incomeVoucher.downloadCompleto" />,
          },
          error: {
            title: <FormattedMessage id="incomeVoucher.houveUmErro" />,
          },
        },
        downloadProgressCallback: (data) => {
          setLoading(true);
          const { totalBytesWritten, totalBytesExpectedToWrite } = data;
          const pctg = 100 * (totalBytesWritten / totalBytesExpectedToWrite);
          if (pctg === 100) {
            setLoading(false);
            toast(
              intl.formatMessage({
                id: "incomeVoucher.erroVerificaGaleriaArquivos",
              })
            );
          }
        },
      });
    }
  }

  async function sendEmail() {
    setLoading(true);
    console.log(dataFile);

    const token = await AsyncStorage.getItem("JWT_TOKEN");
    api
      .post(
        "/income-files/send-file",
        { url: dataFile.file.path },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        console.log(res);
        setLoading(false);
        setModalVisible(!modalVisible);
      })
      .catch(() => {
        toast(intl.formatMessage({ id: "incomeVoucher.erroEnviaEmail" }));
        setLoading(false);
      });
  }

  return (
    <>
      <Spinner
        visible={loading}
        textContent={<FormattedMessage id="incomeVoucher.spinnerCarregando" />}
      />
      {/* let optionArray = [
        'Escolher um arquivo', 'Escolher uma imagem', 'Cancelar'
    ]; */}
      {/* <Modal
                visible={actionSheetVisible}
                animationType="slide"
                transparent={true}>
                <View style={styles.modalCenteredView}>
                    <View style={styles.modalView}>
                        <View style={styles.modalText}>
                            <View style={{ flexDirection: "row", justifyContent: 'flex-end' }}>
                                <View>
                                    <MaterialIcons
                                        onPress={() => setActionSheetVisible(!actionSheetVisible)}
                                        name="close"
                                        size={30}
                                        color="black"
                                        style={styles.closeModal}
                                    />
                                </View>
                            </View>
                            <TouchableOpacity onPress={() => { pickDocument() }}><Text>Escolher um arquivo</Text></TouchableOpacity>
                            <TouchableOpacity onPress={() => { pickImage() }}><Text>Escolher uma imagem</Text></TouchableOpacity>
                        </View>
                    </View>
                </View>

            </Modal> */}

      <HeaderTabs
        title={<FormattedMessage id="incomeVoucher.headerComprovanteRenda" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="incomeVoucher.ultimoContraCheque" />
          </Text>
        }
      />

      <View style={styles.container}>
        <TouchableOpacity style={styles.btnAdd} onPress={showActionSheet}>
          <Image
            source={require("../../../assets/upload_doc.svg")}
            style={styles.imgUpload}
          />
          <Text style={styles.btnText}>
            <FormattedMessage id="incomeVoucher.escolheArquivo" />
          </Text>
        </TouchableOpacity>
        <If condition={fileType === "image"}>
          <Then>
            <Image source={{ uri: file }} style={styles.img} />
          </Then>
          <Else>
            <Text style={{ fontWeight: "bold", marginTop: 20 }}>
              <FormattedMessage id="incomeVoucher.arquivo" />{" "}
              <Text style={{ fontWeight: "normal" }}>{fileName}</Text>
            </Text>
          </Else>
        </If>
      </View>

      <View style={styles.contentBtn}>
        <TouchableOpacity onPress={downloadFile} style={styles.btn}>
          <Text style={styles.textBtn}>
            <FormattedMessage id="incomeVoucher.btnBaixar" />
          </Text>
        </TouchableOpacity>
        <GoBackButton />
      </View>

      <Modal
        animationType="fade"
        transparent={false}
        visible={modalVisible}
        statusBarTranslucent={true}
        onRequestClose={() => setModalVisible((visible) => !visible)}
      >
        <FormattedMessage id="incomeVoucher.docEnviado">
          {(text) => (
            <FormattedMessage id="incomeVoucher.docEnviadoSucesso">
              {(textColor) => (
                <ModalSuccess
                  handleCloseModal={() => {
                    setModalVisible(false);
                  }}
                  text={text}
                  textColor={textColor}
                  img={2}
                  positionHeader={"left"}
                />
              )}
            </FormattedMessage>
          )}
        </FormattedMessage>
      </Modal>
    </>
  );
};

export default IncomeVoucher;
